module.exports = __webpack_public_path__ + "static/media/clue-5.4b749a34.svg";